(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-featured-collection"] && !Shopify.designMode) return;
  try {
    
    var flkty4 = new Flickity( '.featured-carousel', {
      selectedAttraction: 0.12,
      friction: 0.9,
      groupCells: '100%',
      cellAlign: 'left',
      prevNextButtons: false,
      imagesLoaded: true,
      wrapAround: false,
      pageDots: false
    });
    flkty4.resize()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-footer"]) return;
  try {
    
 class CartNote extends HTMLElement {
   constructor() {
     super();

     this.addEventListener('change', debounce((event) => {
       const body = JSON.stringify({ note: event.target.value });
       fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
     }, 300))
     
   }
 }

 customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        input_language: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
        selectorWrapper: this.querySelector('.disclosure'),
      };
      if (!this.elements.panel.classList.contains('currency__list-mobile')) {
        this.elements.button.addEventListener('mouseover', this.openSelector.bind(this));
        this.elements.selectorWrapper.addEventListener('mouseleave', this.hidePanel.bind(this));
      }
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      this.elements.button.classList.remove('hidden');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      this.elements.input_language.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.classList.add('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-reviews-section"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initAllReviewsSliders(){
      var sliders = document.querySelectorAll('.reviews__slider');
      sliders.forEach(function(el){
        if (el._flickity) {
          try { el._flickity.resize(); } catch(e){}
          return;
        }
        var instance = new Flickity(el, {
          prevNextButtons: false,
          wrapAround: true,
          pageDots: true,
          autoPlay: 5000,
          pauseAutoPlayOnHover: true,
          imagesLoaded: true,
          cellAlign: 'center'
        });
        el._flickity = instance;
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllReviewsSliders);
    } else {
      initAllReviewsSliders();
    }

    if (window.Shopify && Shopify.designMode) {
      var reinit = function(){ initAllReviewsSliders(); };
      document.addEventListener('shopify:section:load', reinit);
      document.addEventListener('shopify:section:select', reinit);
      document.addEventListener('shopify:block:select', reinit);
      document.addEventListener('shopify:section:deselect', reinit);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slider"] && !Shopify.designMode) return;
  try {
    
    var presscarousel = new Flickity( '.press-carousel', {

    prevNextButtons: false,
    wrapAround: true,
    pageDots: true,
    autoPlay: 2500,
    pauseAutoPlayOnHover: true,
    imagesLoaded: true
    });

    presscarousel.resize()

  } catch(e) { console.error(e); }
})();
})();
